import CrudRepository from './CrudRepository'
export default class AddNewItemRepository extends CrudRepository {
  constructor () {
    super('core/api/users/new')
  }
}
